import React from 'react'
import {
  Route,
} from 'react-router-dom'

export default ({ component: Component, childrenProps, ...rest }) => (
  <Route {...rest} render={() => <Component {...childrenProps} />} />
)
